import React from "react";
import "./Button.css";

export type ButtonProps = {
  disabled?: boolean;
  variant?: "primary" | "secondary" | "tertiary";
  size?: "sm" | "md" | "lg";
  className?: string;
//   isLoading: boolean;
  label?: string;
  value?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  children?: React.ReactNode;
};

export const Button = ({
    disabled = false,
    variant = "primary",
    size = "md",
    className,
    label,
    value,
    leftIcon,
    rightIcon,
    children,
    ...props
}: ButtonProps & React.ComponentPropsWithoutRef<"button">) => {

    const getVariantClass = () => {
        switch (variant) {
            case "primary":
                return "ds2-button-primary";
            case "secondary":
                return "ds2-button-secondary";
            case "tertiary":
                return "ds2-button-tertiary";
            default:
                return "ds2-button-primary";
        }
    }

    const getSizeStyles = () => {

        switch (size) {
            case "sm":
                return {height: "24px", width: "60px", minWidth: "60px", fontSize: "1rem", paddingRight: "4px"};
            case "md":
            case "lg":
            default:
                return {height: "40px", width: "120px", minWidth: "120px", fontSize: "1.25rem", paddingRight: "8px"};
        }
    }

    const getInnerSizeStyles = () => {
    
        switch (size) {
            case "sm":
                return {padding: "0px", gap: "2px", fontSize: ".85rem"};
            case "md":
            case "lg":
            default:
                return {padding: "8px 12px", gap: "4px", fontSize: "1rem"};
        }
    }
    
    return (
        <button 
            disabled={disabled} 
            className={getVariantClass() + " " + className}
            value={value}
            style={{
                ...getSizeStyles(),
            }}
            {...props} 
        >     
            <div 
                className="ds2-button-inner"
                style={{
                    ...getInnerSizeStyles(),
                }}
            >
                {leftIcon && leftIcon}
                {label && label}
                {children && children}
                {rightIcon && rightIcon}
            </div> 
        
        </button>
    );
}  